import './AccessLevels.scss';
import Component from './AccessLevels.js';

export default Component;
